import { CellContext } from '@tanstack/react-table';
import * as Tooltip from 'components/tooltip';
import { EngageMessage } from 'types/domain';

interface StatsColumnProps {
    info: CellContext<EngageMessage, unknown>;
}

const StatsColumn = ({ info }: StatsColumnProps) => {
    const message = info.row.original;
    const { stats } = message;

    return (
        <>
            {stats &&
                (stats.sent_count > 0 ||
                    stats.unique_open_count > 0 ||
                    stats.bounce_count > 0 ||
                    stats.unsubscribe_count > 0) && (
                    <div className={'h-1.5 w-40 rounded-sm bg-gray-300'}>
                        <div className={'flex overflow-hidden rounded-sm'}>
                            {message.channel === 'sms' && (
                                <Tooltip.Root>
                                    <Tooltip.Trigger asChild aria-label="Delivered">
                                        <div
                                            className="h-1.5 bg-green-500"
                                            style={{ width: `${stats.sent_rate}%` }}
                                        />
                                    </Tooltip.Trigger>
                                    <Tooltip.Content inverse>
                                        <p>
                                            {stats.sent_count} ({stats.sent_rate}%) Delivered
                                        </p>
                                        <Tooltip.Arrow inverse />
                                    </Tooltip.Content>
                                </Tooltip.Root>
                            )}
                            {message.channel !== 'sms' && (
                                <>
                                    <Tooltip.Root>
                                        <Tooltip.Trigger asChild aria-label="Opened">
                                            <div
                                                className="h-1.5 bg-green-500"
                                                style={{
                                                    width: `${stats.open_rate}%`,
                                                }}
                                            />
                                        </Tooltip.Trigger>
                                        <Tooltip.Content inverse>
                                            <p>
                                                {stats.unique_open_count} ({stats.open_rate}%)
                                                Opened
                                            </p>
                                            <Tooltip.Arrow inverse />
                                        </Tooltip.Content>
                                    </Tooltip.Root>

                                    <Tooltip.Root>
                                        <Tooltip.Trigger asChild aria-label="Bounced">
                                            <div
                                                className="h-1.5 bg-orange-500"
                                                style={{
                                                    width: `${stats.bounce_rate}%`,
                                                }}
                                            />
                                        </Tooltip.Trigger>
                                        <Tooltip.Content inverse>
                                            <p>
                                                {stats.bounce_count} ({stats.bounce_rate}%) Bounced
                                            </p>
                                            <Tooltip.Arrow inverse />
                                        </Tooltip.Content>
                                    </Tooltip.Root>
                                </>
                            )}
                            <Tooltip.Root>
                                <Tooltip.Trigger asChild aria-label="Unsubscribed">
                                    <div
                                        className="h-1.5 bg-red-500"
                                        style={{
                                            width: `${stats.unsubscribe_rate}%`,
                                        }}
                                    />
                                </Tooltip.Trigger>
                                <Tooltip.Content inverse>
                                    <p>
                                        {stats.unsubscribe_count} ({stats.unsubscribe_rate}%)
                                        Unsubscribed
                                    </p>
                                    <Tooltip.Arrow inverse />
                                </Tooltip.Content>
                            </Tooltip.Root>
                        </div>
                    </div>
                )}
            {(!stats ||
                (stats.sent_count === 0 &&
                    stats.unique_open_count === 0 &&
                    stats.bounce_count === 0 &&
                    stats.unsubscribe_count === 0)) && (
                <div className={'h-1.5 w-40 rounded-sm bg-gray-300'}>
                    <Tooltip.Root>
                        <Tooltip.Trigger asChild aria-label="No stats">
                            <div className={`h-1.5 w-full rounded-md bg-gray-300`} />
                        </Tooltip.Trigger>
                        <Tooltip.Content inverse>
                            <p>Check back later for stats</p>
                            <Tooltip.Arrow inverse />
                        </Tooltip.Content>
                    </Tooltip.Root>
                </div>
            )}
        </>
    );
};

export { StatsColumn };
